"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowOfflineButtonContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ShowOfflineButton_1 = require("../../react/components/ShowOfflineButton");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ShowOfflineButtonContainer = function (_a) {
    var onClick = _a.onClick;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.ILayoutContext), 2), translate = _b[0].translate, breakpoint = _b[1].breakpoint;
    return (0, jsx_runtime_1.jsx)(ShowOfflineButton_1.ShowOfflineButton, { translate: translate, breakpoint: breakpoint, onClick: onClick });
};
exports.ShowOfflineButtonContainer = ShowOfflineButtonContainer;
exports.ShowOfflineButtonContainer.displayName = "ShowOfflineButtonContainer";
//# sourceMappingURL=ShowOfflineButtonContainer.js.map